import { Injectable } from '@angular/core';
import { DefaulterListAllDataResponseData } from '../interfaces/defaulter-list';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root',
})
export class DeafulterListService extends ApiService {
  public fetchDefaulterListDetails(
    pageNo: number,
    reqData: any
  ): Observable<DefaulterListAllDataResponseData> {
    console.log(reqData, 'req data');
    return this.get<DefaulterListAllDataResponseData>(
      this.replacePathInfo(ROUTES.DEFAULTER_LIST_DATA, {
        pageNo: pageNo,
      }),
      {
        params: reqData,
      }
    );
  }

  public getDefaulterList(
    reqPayload: any
  ): Observable<DefaulterListAllDataResponseData> {
    return this.post<DefaulterListAllDataResponseData>(ROUTES.DEFAULTER_LIST, {
      body: reqPayload,
    });
  }

  public getListData(pageNo: number, reqData: any): Observable<any> {
    return this.get<any>(
      this.replacePathInfo(ROUTES.REACH_PENDING_DATA, {
        pageNo: pageNo,
      }),
      {
        params: reqData,
      }
    );
  }
  public editReachDetails(id: any, memKey: any, bodyObj: any): Observable<any> {
    return this.patch<any>(
      this.replacePathInfo(ROUTES.EDIT_REACH_DETAILS, {
        id: id,
        memKey: memKey

      }),
      {
        body: bodyObj,
      }
    );
  }
  public addReachDetails(id: any, bodyObj: any): Observable<any> {
    return this.post<any>(this.replacePathInfo(ROUTES.ADD_REACH_DETAILS, {
      id: id,
    }),
      {
        body: bodyObj,
      }
    );
  }
  public getReachNotesDetails(id: any): Observable<any> {
    return this.get<any>(this.replacePathInfo(ROUTES.GET_REACH_NOTE_DETAILS, {
      id: id,
    }),
    );
  }
  public markAsExpiredInReach(id: any, data: any): Observable<any> {
    return this.post<any>(
      this.replacePathInfo(ROUTES.REACH_MARK_AS_EXPIRED, {
        id: id,
      }),
      {
        body: data,
      }
    );
  }
}
